import React, { useState } from "react";


type useElementFocusHook = [
    boolean,
    {
        focusEventHandler: ( _: React.FocusEvent< HTMLElement > ) => void
        blurEventHandler: ( _: React.FocusEvent<HTMLElement> ) => void
    }
]

/**
 * useElementFocus helps with keeping track of focus on elements
 *
 * @param isFocused initial state for hook
 */
export function useElementFocus( isFocused: boolean = false ): useElementFocusHook {
    const [ state, setState ] = useState( isFocused );

    const handlers = {
        focusEventHandler: ( _: React.FocusEvent< HTMLElement > ) => {
            setState( true );
        },
        blurEventHandler: ( _: React.FocusEvent<HTMLElement> ) => {
            setState( false );
        }
    }

    return [ state, handlers ];
}